{
  "commentForm": {
    "placeholder": "Añadir un comentario"
  },
  "commentList": {
    "title": "Todos los comentarios"
  },
  "viewAllComments": "Ver todos los comentarios",
  "edited": "Editado",
  "comment": "Comentario",
  "comments": "Comentarios",
  "moveComments": "Mueva los comentarios aquí",
  "showComments": "Mostrar comentarios",
  "hideComments": "Ocultar comentarios",
  "justNow": "Justo ahora",
  "deleteConfirmation": {
    "title": "Eliminar comentario",
    "description": "¿Estás seguro de que quieres eliminar este comentario? Esta acción no se puede revertir."
  },
  "addComment": "Añadir comentario",
  "cancelComment": "Cancelar la adición de un comentario"
}